module.exports = __webpack_public_path__ + "static/media/Terms_de.67f28a9c.md";